import { BenefitType, Subsidy, Subsidies } from "#/lib/carrot-api/types/Subsidy"
import { reimbursementCategoryNameMessageKeys } from "../components/views/reimbursements/reimbursementCategoryNameMessageKeys"

export class CategoryCoverage {
  adoption: boolean
  gc: boolean
  mlt: boolean
  pregnancy: boolean
  gac: boolean
  fertility: boolean
  preservation: boolean
  medication: boolean
  qme: boolean
  hasAnyNonQme: () => boolean = () =>
    this.adoption ||
    this.gc ||
    this.mlt ||
    this.pregnancy ||
    this.gac ||
    this.fertility ||
    this.preservation ||
    this.medication
}

export function getCategoryCoverage(subsidies: Subsidies | null): CategoryCoverage {
  const coverage: CategoryCoverage = new CategoryCoverage()

  subsidies?.forEach((subsidy: Subsidy) => {
    switch (subsidy.reimbursementCategoryNameMessageKey) {
      case reimbursementCategoryNameMessageKeys.ADOPTION_AND_GC: {
        coverage.adoption = true
        coverage.gc = true
        break
      }
      case reimbursementCategoryNameMessageKeys.ADOPTION: {
        coverage.adoption = true
        break
      }
      case reimbursementCategoryNameMessageKeys.GC: {
        coverage.gc = true
        break
      }
      case reimbursementCategoryNameMessageKeys.MEDICATION: {
        coverage.medication = true
        break
      }
      case reimbursementCategoryNameMessageKeys.QME: {
        coverage.qme = true
        break
      }
      case reimbursementCategoryNameMessageKeys.M_LT: {
        coverage.mlt = true
        break
      }
      case reimbursementCategoryNameMessageKeys.FERTILITY: {
        coverage.fertility = true
        break
      }
      case reimbursementCategoryNameMessageKeys.FERTILITY_AND_PRESERVATION: {
        coverage.fertility = true
        coverage.preservation = true
        break
      }
      case reimbursementCategoryNameMessageKeys.GAC: {
        coverage.gac = true
        break
      }
      case reimbursementCategoryNameMessageKeys.M_LT_GAC: {
        coverage.mlt = true
        coverage.gac = true
        break
      }
      case reimbursementCategoryNameMessageKeys.PREGNANCY: {
        coverage.pregnancy = true
        break
      }
      case reimbursementCategoryNameMessageKeys.PREGNANCY_M_LT: {
        coverage.pregnancy = true
        coverage.mlt = true
        break
      }
      case reimbursementCategoryNameMessageKeys.PRESERVATION: {
        coverage.preservation = true
        break
      }
      case reimbursementCategoryNameMessageKeys.FERTILITY_M_LT: {
        coverage.fertility = true
        coverage.preservation = true
        coverage.mlt = true
        break
      }
      case reimbursementCategoryNameMessageKeys.FERTILITY_GC_ADOPTION: {
        coverage.fertility = true
        coverage.preservation = true
        coverage.adoption = true
        coverage.gc = true
        break
      }
    }
  })

  return coverage
}

const FERTILITY_CATEGORY_KEYS: ReadonlyArray<string> = [
  reimbursementCategoryNameMessageKeys.FERTILITY,
  reimbursementCategoryNameMessageKeys.PRESERVATION,
  reimbursementCategoryNameMessageKeys.FERTILITY_AND_PRESERVATION,
  reimbursementCategoryNameMessageKeys.FERTILITY_M_LT,
  reimbursementCategoryNameMessageKeys.FERTILITY_GC_ADOPTION
]

export function isFertilityCategory(subsidy: Subsidy): boolean {
  return FERTILITY_CATEGORY_KEYS.includes(subsidy.reimbursementCategoryNameMessageKey)
}

export function hasCreditsForFertility(subsidies: Subsidies | null): boolean {
  return subsidies?.some((s) => isFertilityCategory(s) && s.benefitType === BenefitType.CREDIT) ?? false
}

// Absent isReimbursable means reimbursable.
export function isReimbursableFertilityFund(subsidy: Subsidy): boolean {
  return isFertilityCategory(subsidy) && subsidy.benefitType !== BenefitType.CREDIT && subsidy.isReimbursable !== false
}

export function hasAncillaryFundsForFertility(subsidies: Subsidies | null): boolean {
  return hasCreditsForFertility(subsidies) && (subsidies?.some(isReimbursableFertilityFund) ?? false)
}
